//Navigation
var hnav = $('#h-nav'),
    hnavPos = hnav.offset().top,
    hnavList = $('#h-n-list'),
    hnavToggle = $('#h-n-b-toggler');
function navCalc(){
  var scrValue = $(this).scrollTop(),
      hnavInner = hnav.innerHeight();
  $('#h-n-b-toggler, .nav-item').removeClass('active');
  hnavList.removeAttr('style');
  if(scrValue > hnavPos){
    hnav.addClass('h-navfixed');
  }else{
    hnav.removeClass('h-navfixed');
    if(hnavList.css('display') == 'none'){
      hnavList.css('top', hnavPos + hnavInner - scrValue + 'px');
    }
  }
}

jQuery(document).ready(function(){
  //NavigationControl
  navCalc();
  $(window).on('resize scroll', navCalc);
  hnavToggle.off('click');
  hnavToggle.on('click', function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      hnavList.stop().slideDown(300, 'easeInOutQuad', function(){
        $(this).find('.nav-item').each(function(i){
          $(this).delay(90*i).queue(function(){ $(this).stop().addClass('active');});
        });
      });
    }else{
      hnavList.stop().slideUp(300, 'easeInOutQuad', function(){
        $(this).find('.nav-item').removeClass('active');
      });
    }
  });

  //Totop
  $('#f-totop').on('click', function(){
    $('html, body').stop().animate({scrollTop: 0}, 600, 'easeInOutQuad');
    return false;
  });

  //Rellax
  if($('#h-i-image #h-i-i-plx').length){
    var intro = new Rellax('#h-i-image #h-i-i-plx', {speed: -6, center: true});
  }
  if($('#h-i-imagesub #h-i-i-plx').length){
    var introsub = new Rellax('#h-i-imagesub #h-i-i-plx', {speed: -3, center: true});
  }

  //Swiper
  if($('#i-list').length){
    var instructorSwiper = new Swiper('#i-list', {
        speed: 600,
        autoHeight: true,
        centeredSlides: true,
        grabCursor: true,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      });
  }
  if($('.id-c-image').length){
    var instructorContentSwiper = new Swiper('.id-c-image', {
        speed: 600,
        centeredSlides: true,
        grabCursor: true,
        slidesPerView: 1,
        autoplay: {
          delay: 3600,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination'
        }
      });
  }

  //Inview
  var i;
  $('#h-i-catch, #events, #instructor, #contact, #newsdetail, #about').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){ $(this).addClass('anima');}
  });
  $('#service, #works').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).addClass('anima');
      $(this).find('section').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('#banner').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).addClass('anima');
      $(this).find('li').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('#servicedetail, #instructorlist, #instructordetail, #news').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){
      i = 0;
      $(this).addClass('anima');
      $(this).find('article').each(function(i){
        $(this).delay(180*i).queue(function(){ $(this).stop().addClass('anima');});
      });
    }
  });
  $('#h-i-o-title').on('inview', function(event, isInView, visiblePartX, visiblePartY){
    if(isInView){ $(this).addClass('anima');}
    else{ $(this).removeClass('anima');}
  });
});
